// Client\client-vite\src\pages\Dealers\DealerInventoryAddPage.tsx

import React from "react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import {
    InputOTP,
    InputOTPGroup,
    InputOTPSlot,
} from "@/components/ui/input-otp"
import { Separator } from "@/components/ui/separator"
import { toast } from "sonner"

// VIN helpers
//  const VIN_CHAR_REGEX = /^[A-HJ-NPR-Z0-9]$/;   // per-slot validator (no I,O,Q)
const VIN_FULL_REGEX = /^[A-HJ-NPR-Z0-9]{17}$/; // full VIN validator
const VIN_CHAR_PATTERN = "[A-HJ-NPR-Z0-9]"; 

export function DealerInventoryAddPage() {
    const [value, setValue] = React.useState("")

    const handleChange = (next: string) => {
        // Uppercase + strip any invalid chars proactively
        const clean = next.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, "")
        setValue(clean)
    }

    const handleComplete = (vin: string) => {
        const upper = vin.toUpperCase()
        if (VIN_FULL_REGEX.test(upper)) {
            toast.success(`VIN captured: ${upper}`)
            // TODO: call your decode endpoint and route to next step
            // await fetch(`${API_URL}/inventory/decode-vin?vin=${upper}`, { credentials: "include" })
            // navigate(`/dealers/inventory/add/details?vin=${upper}`)
        } else {
            toast.error("Invalid VIN. Check for I, O, or Q and length 17.")
        }
    }

    return (
        <div className="mx-auto max-w-3xl p-4 md:p-6">
            <Card className="border-0 shadow-lg">
                <CardHeader>
                    <CardTitle className="text-2xl">Enter Vehicle By VIN:</CardTitle>
                </CardHeader>
                <CardContent className="space-y-6">
                    <div className="space-y-2">
                        <InputOTP
                            maxLength={17}
                            value={value}
                            inputMode="text"
                            pattern={VIN_CHAR_PATTERN}   // <-- pass the RegExp, not a string
                            onChange={handleChange}
                            onComplete={handleComplete}
                        >
                            <InputOTPGroup>
                                {Array.from({ length: 17 }).map((_, i) => (
                                    <InputOTPSlot key={i} index={i} />
                                ))}
                            </InputOTPGroup>
                        </InputOTP>


                        <div className="text-center text-sm text-muted-foreground">
                            {value === "" ? (
                                <>17 characters • A–Z (no I, O, Q) and 0–9 • paste works</>
                            ) : VIN_FULL_REGEX.test(value) ? (
                                <>
                                    <span className="text-white font-extrabold">Vin entered: </span>
                                    <span className="font-mono">{value}</span></>
                            ) : (
                                <>Length: {value.length}/17</>
                            )}
                        </div>

                        <div className="flex items-center justify-center gap-2 pt-2">
                            <Button
                                type="button"
                                variant="secondary"
                                onClick={() =>
                                    navigator.clipboard
                                        .readText()
                                        .then((t) =>
                                            setValue(
                                                t.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, "")
                                            )
                                        )
                                        .catch(() => toast.error("Could not read clipboard"))
                                }
                            >
                                Paste VIN
                            </Button>

                            <Button
                                type="button"
                                disabled={!VIN_FULL_REGEX.test(value)}
                                onClick={() => handleComplete(value)}
                            >
                                Continue
                            </Button>
                        </div>
                    </div>

                    <Separator />

                    {/* Optional: Alternate entry */}
                    <div className="text-center text-sm text-muted-foreground">
                        Don’t have the VIN right now?{" "}
                        <Button
                            type="button"
                            variant="link"
                            className="px-1"
                            onClick={() =>
                                toast.message("Coming soon", {
                                    description: "Enter by Year/Make/Model or scan VIN",
                                })
                            }
                        >
                            Enter by YMM or scan
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}
